const $window = $(window);

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ヘッダー開閉
import {headerToggle} from "../include/module";
headerToggle();

import {scrollAnimation} from "../include/module";

$(window).on('load', function(){
  setTimeout(function () {
    scrollAnimation();
  }, 100);
});

$(window).on('scroll', function(){
  scrollAnimation();
});



// WEBPACK FOOTER //
// ./src/assets/js/event/script.js